import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../../UI/Common';
import ActionsDropdown from '../../Dashboard/helpers/ActionsDropdown';
import { dashboardCustomizeMonitoringPointData, MPColumns } from './constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { CustomInput } from 'reactstrap';
import { getSharedDefaultStyles, getSpacingAround } from './functions';

const DashboardCustomWidget4 = ({ values, ...props }) => {
  const { t } = useTranslation('app');
  const [search, updateSearch] = React.useState(null);
  function afterSearch(newResult) {
    const filteredSensorIds = [];
    newResult.forEach((element) => {
      filteredSensorIds.push(element.sensorId);
    });
    updateSearch(filteredSensorIds);
  }
  function getBgColor(alarmPriority) {
    let color = '';
    switch (alarmPriority) {
      //green
      case 0:
        color = '#75e5d0';
        break;
      case 1:
        //yellow
        color = '#fcf496';
        break;
      case 2:
        //red
        color = '#ffb0be';
        break;
      default:
        //blue
        color = '#6bcfed';
        break;
    }
    return color;
  }
  const actions = [
    {
      label: 'Ack alarm',
      action: () => {},
    },
    {
      label: 'Show trend chart',
      action: () => {},
    },
  ];

  function getStyles() {
    let val = parseInt(values.width);
    return {
      width: Number.isNaN(val) ? '100%' : val,
      ...getSharedDefaultStyles(),
      ...getSpacingAround(
        values.extraProperties.spacingTop,
        values.extraProperties.spacingRight,
        values.extraProperties.spacingBottom,
        values.extraProperties.spacingLeft,
      ),
    };
  }

  return (
    <div
      style={getStyles()}
      className={props.isActive === values.id ? 'selected-widget' : ''}
    >
      <div className="d-flex justify-content-between align-items-end mb-10">
        <div>
          {values.title ? <h1>{values.title}</h1> : null}
          {values.description ? (
            <span style={{ fontStyle: 'italic' }}>{values.description}</span>
          ) : null}
        </div>
        <div className="d-flex flex-1 justify-content-end align-items-end">
          {/* <ActionsDropdown options={actions} /> */}
        </div>
      </div>
      {/* <ToolkitProvider
        keyField="sensorId"
        data={dashboardCustomizeMonitoringPointData}
        columns={MPColumns}
        search={{
          afterSearch,
        }}
      >
        {(props) => (
          <div>
            <Input
              labelHidden
              //   containerClass="mb-0"
              placeholder="Search ..."
              value={props.searchProps.searchText}
              onChange={(e) => props.searchProps.onSearch(e.target.value)}
            />

            <div style={{ display: 'none' }}>
              <BootstrapTable {...props.baseProps} />
            </div>
          </div>
        )}
      </ToolkitProvider> */}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${parseInt(
            values.extraProperties.numberOfColumns || 1,
          )}, 1fr)`,
          columnGap: parseInt(values.extraProperties.columnGap || 0),
          rowGap: parseInt(values.extraProperties.rowGap || 0),
        }}
      >
        {values.extraProperties.alarms
          .filter((alarm) => {
            if (search === null) {
              return alarm;
            } else {
              return search.includes(alarm.sensorId);
            }
          })
          .filter((alarm) => {
            if (props.isAlert) {
              return alarm.alarmPriority !== 0;
            } else return alarm;
          })
          .map((al) => {
            return (
              <div
                key={al.sensorId}
                className="d-flex"
                style={{
                  backgroundColor: getBgColor(al.alarmPriority),
                  // flex: getFlexByColumn(),
                  // minWidth: 240,
                }}
              >
                <div
                  className="d-flex flex-column w-100"
                  style={{ padding: 10 }}
                >
                  <div className="d-flex">
                    <div className="flex-1">
                      <span style={{ fontSize: 14, fontWeight: '500' }}>
                        {al.name}
                      </span>
                      <br />
                      <span style={{ fontSize: 12 }}>{al.location}</span>
                      <br />
                      <span style={{ fontSize: 12 }}>{al.groupName}</span>
                      <br />
                      {al.alarmPriority === 2 && (
                        <>
                          <span style={{ fontSize: 10 }}>
                            {al.timeDetected}
                          </span>
                          <br />
                        </>
                      )}
                      {al.alarmPriority !== 0 && (
                        <span style={{ fontSize: 10 }}>{al.alarmType}</span>
                      )}
                    </div>
                    {/* <div>
                    <CustomInput type="checkbox" checked />
                  </div> */}
                  </div>
                  <div style={{ textAlign: 'end' }}>
                    <span
                      style={{ fontSize: 16, fontWeight: '500', lineHeight: 1 }}
                    >
                      {al.units}
                    </span>
                    <br />
                    <span
                      style={{
                        fontSize: 22,
                        fontWeight: 'bold',
                        lineHeight: 2,
                      }}
                    >
                      {al.textValue}
                    </span>
                    <br />
                    <span className="m-dashboard-time-info">{al.timeInfo}</span>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default DashboardCustomWidget4;
